import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { Button } from "../../button";
import { useBlockComponentContext } from "../";
export const BlockContinueButton = ({ translationKey }) => {
    const { Translated } = useBlockComponentContext();
    const { isSubmitting } = useFormikContext();
    return (_jsx(Button, { size: "large", color: "primary", type: "submit", disabled: isSubmitting, children: _jsx(Translated, { translationKey: translationKey }) }));
};
